import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.verilog = bracketIndenting()
